import { db } from '../firebase';
import { updateDoc, doc, getDoc } from 'firebase/firestore';

export const orderTrackingWasSent = (item) =>
  !!(item?.trackingSent || item?.trackingEmailSentAt);

export const saveOrderTracking = async (collectionName, orderId, trackingNumber, trackingLink) => {
  const number = String(trackingNumber || '').trim();
  const link = String(trackingLink || '').trim();
  if (!number || !link) {
    throw new Error('Completá el número y el link de seguimiento.');
  }
  const orderRef = doc(db, collectionName, orderId);
  const orderDoc = await getDoc(orderRef);
  if (!orderDoc.exists()) {
    throw new Error('No se encontró el documento para actualizar.');
  }
  await updateDoc(orderRef, {
    trackingNumber: number,
    trackingLink: link,
    trackingSent: false,
    sendTrackingEmail: true,
    trackingEmailError: '',
    trackingUpdatedAt: new Date()
  });
  return { trackingNumber: number, trackingLink: link };
};
